const Units = [{
        id: 1,
        name: "unit"
    },
    {
        id: 2,
        name: "meter"
    },
    {
        id: 3,
        name: "roll"
    }
];

module.exports = Units